import React from "react";
import Label from "components/shared/form/Label";
import Hint from "components/shared/fields/Hint";

type CheckboxFieldWrapperProps = {
  children: React.ReactNode;
  label?: string;
  required?: boolean;
  hint?: string;
};

export default function CheckboxFieldWrapper({
  label,
  required,
  children,
  hint,
}: CheckboxFieldWrapperProps) {
  return (
    <div className="control-group">
      {label && <Label label={label} required={required} />}
      <div className="controls">
        <div className="border-box px-3 py-2">{children}</div>
        {hint && <Hint hint={hint} />}
      </div>
    </div>
  );
}
